package uz.ferro.erp.feature.auth

import js.objects.jso
import mui.system.Box
import react.FC
import react.Props
import react.useEffectOnce
import react.useRef
import web.dom.Element
import web.html.HTMLDivElement

external interface InitializeProps {
    @JsName("client_id")
    var clientId: String?
    var callback: (Any) -> Unit
}

external interface GoogleId {
    fun initialize(props: dynamic)
    fun renderButton(element: Element, props: dynamic)
    fun prompt()
}

external interface GoogleAccount {
    var id: GoogleId
}

external interface Google {
    var accounts: GoogleAccount
}

external var google: Google

external interface GoogleAuthButtonProps : Props {
    var onSuccess: (String) -> Unit
}

val GoogleAuthButton = FC<GoogleAuthButtonProps> {props->
    val buttonRef = useRef<HTMLDivElement>()

    fun handleCallback(cred: dynamic) {
        props.onSuccess(cred.credential)
    }

    useEffectOnce {
        val el = buttonRef.current ?: return@useEffectOnce
        google.accounts.id.initialize(jso {
            client_id = "795044884434-0advpmkq88gv33kv1fjssqj1uidoufmm.apps.googleusercontent.com"
            callback = fun(cred: Any) {
                handleCallback(cred)
            }
        })

        google.accounts.id.renderButton(
            element = el,
            props = jso {
                theme = "outline"
                size = "large"
            }
        )

        google.accounts.id.prompt()
    }

    Box {
        this.ref = buttonRef
    }
}